import {useCallback, useState} from "react";
import {DEFAULT_LOCALE, isSupportedLocale, SupportedAppLocale} from "../util/LocalePreferences";
import UserPreferencesStore from "../util/UserPreferencesStore";

function getInitialLocale(): SupportedAppLocale {
    const storedLocale = UserPreferencesStore.read().locale;

    return isSupportedLocale(storedLocale)
        ? storedLocale
        : DEFAULT_LOCALE;
}

export default function useLocale(): [SupportedAppLocale, (nextLocale: SupportedAppLocale) => void] {
    const [locale, setLocaleState] = useState<SupportedAppLocale>(() => getInitialLocale());

    const setLocale = useCallback((nextLocale: SupportedAppLocale) => {
        setLocaleState(nextLocale);
        UserPreferencesStore.write({locale: nextLocale});
    }, []);

    return [locale, setLocale];
}
